export const CREATE_WORK_ORDER_REQUEST_COPY = {
  title: "New task",
  description: "Create a task for this workspace.",
  titleField: "Title",
  titlePlaceholder: "Title",
  placeholder: "Describe the task. You can attach images, videos, and audio.",
  attach: "Attach image, video, or audio",
  dictate: "Dictate",
  stopDictation: "Stop dictation",
  microphoneDenied: "Microphone access was denied. Allow access and try again.",
  attachedImages: "Attached files",
  openImage: "Open attachment",
  closeImage: "Close attachment",
  deleteImage: "Delete attachment",
  create: "Create task",
  creating: "Creating...",
  expand: "Open full screen",
  collapse: "Exit full screen",
} as const;
